var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "brick-base",
    {
      staticClass: "brick-circle",
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        },
        mouseup: function($event) {
          return _vm.$emit("mouseup", $event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }